export const HEADER_FROM_2C_S3 = { owner: '2.C', stage: 's3' };
export const HEADER_FROM_2L_S1 = { owner: '2.L', stage: 's1' };
export const HEADER_FROM_1M1_S3 = {
    owner: '1.M-1',
    stage: 's3',
};
//# sourceMappingURL=change-batch-senders.js.map